import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { AWS_CLOUD_FRONT_URL } from "../../lib/constants";

interface HomepageTopbarProps {
  isScrolled: boolean;
}

const HomepageTopbar: React.FC<HomepageTopbarProps> = ({ isScrolled }) => {
  const location = useLocation();
  const pathname = location.pathname.slice(1);

  return (
    <>
      <div id="topbartopscroll" className="mb-[70px] "></div>
      <header
        className={`fixed top-0 w-full flex-nowrap gap-x-10 h-[76px] flex items-center justify-between py-3 xxl:py-5 xxxl:py-7 px-[15vw] transition-all duration-300 ease-in-out ${
          isScrolled ? "bg-white text-black" : "bg-customGreenColor text-white"
        }`}
        style={{ zIndex: 100 }}
      >
        <Link
          to="/"
          className="transition-transform duration-300 hover:scale-105 animate-fadeIn"
        >
          <img
            src={
              isScrolled
                ? `${AWS_CLOUD_FRONT_URL}/AfroCart_Logo_Black.png`
                : `${AWS_CLOUD_FRONT_URL}/AfroCart_Logo_White.png`
            }
            className="w-[150px] md:w-[200px] h-[40px] md:h-[52px] transition-opacity duration-300"
            alt="homepage_logo"
          />
        </Link>

        <div className="flex gap-[1.5rem] tracking-wide font-helvetica text-[13px] xxl:text-[16px] animate-fadeIn">
          <Link
            to="/about"
            className={`transition-all duration-100 ease-in-out hover:opacity-80 hover:scale-105 ${
              pathname === "about" ? "font-bold" : ""
            } whitespace-nowrap`}
          >
            About Us
          </Link>
          <Link
            to="/ourVendors"
            className={` hover:opacity-80 transition-all duration-100 ease-in-out hover:opacity-80 hover:scale-105 ${
              pathname === "vendors" ? "font-bold" : ""
            } whitespace-nowrap`}
          >
            Vendors
          </Link>
          <Link
            to="/contact-us"
            className={` hover:opacity-80 transition-all duration-100 ease-in-out hover:opacity-80 hover:scale-105 ${
              pathname === "contact-us" ? "font-bold" : ""
            } whitespace-nowrap`}
          >
            Contact Us
          </Link>
          <Link
            to="/faqs"
            className={` hover:opacity-80 transition-all duration-100 ease-in-out hover:opacity-80 hover:scale-105 ${
              pathname === "faqs" ? "font-bold" : ""
            } whitespace-nowrap`}
          >
            FAQ
          </Link>
        </div>
        <div className="space-x-6 font-helvetica tracking-wide text-xs xxl:text-base hidden xs:block flex-nowrap animate-fadeIn">
          <Link
            to="/vendor-login"
            className={`text-nowrap hover:opacity-80 font-medium text-[13px] xxl:text-[16px]`}
          >
            Sign in
          </Link>
          <Link
            to="/signup"
            className={`text-nowrap hover:opacity-80 transition-all duration-100 ease-in-out hover:opacity-80 hover:scale-105 ${
              isScrolled ? "bg-black text-white" : "bg-white text-black"
            } font-semibold  rounded-md py-[5%] px-3`}
          >
            Sign up
          </Link>
        </div>
      </header>
    </>
  );
};
export default HomepageTopbar;
